import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerhireinvimannagarpune() {



  const cardData = {
"keyword": "Tempo Traveller hire in Viman Nagar Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller hire in Viman Nagar, Pune for airport transfers, corporate travel, IT staff transportation, family trips, weddings, school tours, and outstation group journeys. Our fleet includes 9, 12, 14, 17, 20, and 26-seater Tempo Travellers with AC, pushback seats, spacious interiors, and experienced drivers familiar with Viman Nagar, Kalyani Nagar, Yerwada, and Pune Airport routes. We ensure safe, comfortable, and punctual group travel with doorstep pickup from Viman Nagar, Phoenix Mall area, and surrounding localities.",

"topPlaces": [
{
"title": "Tadoba National Park",
"description":
"Tadoba National Park is one of Maharashtra’s best tiger reserves known for wildlife safaris, forests, and adventure experiences. It is a popular long-distance group tour destination from Pune."
},
{
"title": "Panhala Fort",
"description":
"Panhala Fort is a historic hill fort near Kolhapur known for Maratha history, scenic viewpoints, and trekking. It is a great heritage group travel destination from Pune."
},
  {
"title": "Bhimashankar Wildlife Sanctuary",
"description":
"Bhimashankar Wildlife Sanctuary is a rich biodiversity zone in the Western Ghats known for trekking trails, dense forests, and the famous Jyotirlinga temple. It is a popular nature and spiritual group travel destination from Pune."
},
{
"title": "Velas Beach",
"description":
"Velas Beach is a clean and quiet Konkan beach famous for Olive Ridley turtle conservation and eco-tourism. It is ideal for peaceful group trips and nature tours from Pune."
},

{
"title": "Jawhar",
"description":
"Jawhar is a tribal hill station known for waterfalls, forts, and Warli art culture. It is a peaceful offbeat group travel destination from Pune."
},
{
"title": "Satara Kaas Pathar",
"description":
"Satara Kaas Pathar is a UNESCO flower valley famous for seasonal blooms, scenic landscapes, and monsoon beauty. It is a top nature group tour destination from Pune."
},
{
"title": "Ratanwadi",
"description":
"Ratanwadi is a small village near Bhandardara known for Ratangad Fort trekking and natural beauty. It is popular for adventure group trips from Pune."
},
{
"title": "Harihar Fort",
"description":
"Harihar Fort is a unique rock-cut fort famous for its steep staircase and trekking challenge. It is a popular adventure group trekking destination from Pune."
},
{
"title": "Kalsubai Peak",
"description":
"Kalsubai Peak is the highest peak in Maharashtra known for trekking, sunrise views, and adventure tourism. It is ideal for group trekking trips from Pune."
},
{
"title": "Rajmachi Fort",
"description":
"Rajmachi Fort is a historic fort between Lonavala and Karjat known for trekking routes, caves, and monsoon beauty. It is a favorite group trekking destination from Pune."
}
],



services: [
  {
    name: "14 Seater Tempo Traveller Viman Nagar",
    description: "14 seater Tempo Traveller Viman Nagar service provides comfortable transportation for airport transfers, corporate travel, sightseeing tours, family outings, and outstation journeys. Spacious seating and luggage space ensure smooth travel experiences suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient 14 seater traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Viman Nagar",
    description: "17 seater Tempo Traveller Viman Nagar service offers spacious transportation for employee outings, pilgrimage journeys, educational tours, family vacations, and tourist travel. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for larger passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Viman Nagar Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "20 Seater Tempo Traveller Viman Nagar",
    description: "20 seater Tempo Traveller Viman Nagar service provides reliable transportation for corporate events, airport transfers, wedding functions, office outings, and group travel requirements. Spacious interiors and luggage capacity ensure comfortable journeys suitable for medium and large passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Viman Nagar Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "Tempo Traveller for Airport Pickup Viman Nagar",
    description: "Tempo Traveller for airport pickup Viman Nagar service provides reliable transportation for tourists, business travelers, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and Pune Airport across Viman Nagar Pune. Flexible booking options allow convenient airport traveller reservations."
  },
  {
    name: "Tempo Traveller for Corporate Viman Nagar",
    description: "Tempo Traveller for corporate Viman Nagar service offers professional transportation for business meetings, office outings, conferences, employee travel, and executive journeys. Spacious seating and smooth travel performance ensure comfortable experiences suitable for office teams and corporate passengers. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from offices, hotels, commercial locations, and business hubs across Viman Nagar Pune. Flexible booking options allow convenient corporate traveller reservations."
  },
  {
    name: "Tempo Traveller for IT Employees Viman Nagar",
    description: "Tempo Traveller for IT employees Viman Nagar service provides dependable transportation for employee movement, office shuttle services, airport transfers, company outings, and business travel. Spacious seating and comfortable interiors ensure smooth journeys suitable for IT professionals and executive teams. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from offices, homes, hotels, and IT locations across Viman Nagar Pune. Flexible booking options allow convenient IT employee traveller reservations."
  },
  {
    name: "Tempo Traveller for Wedding Viman Nagar",
    description: "Tempo Traveller for wedding Viman Nagar service offers stylish transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "Viman Nagar to Shirdi Tempo Traveller",
    description: "Viman Nagar to Shirdi Tempo Traveller service provides comfortable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Viman Nagar Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Viman Nagar to Mumbai Tempo Traveller",
    description: "Viman Nagar to Mumbai Tempo Traveller service offers reliable long-distance transportation for corporate travel, sightseeing journeys, airport transfers, family trips, and tourist travel. Spacious seating and smooth expressway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Viman Nagar Pune. Flexible booking options allow convenient Mumbai traveller reservations."
  },
  {
    name: "Viman Nagar to Lonavala Tempo Traveller",
    description: "Viman Nagar to Lonavala Tempo Traveller service provides comfortable hill station transportation for sightseeing tours, family vacations, office outings, and weekend trips from Viman Nagar Pune. Spacious interiors and smooth expressway travel ensure pleasant journeys suitable for tourist and corporate groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Viman Nagar Pune. Flexible booking options allow convenient Lonavala traveller reservations."
  },
  {
    name: "Viman Nagar to Mahabaleshwar Tempo Traveller",
    description: "Viman Nagar to Mahabaleshwar Tempo Traveller service offers dependable transportation for hill station vacations, sightseeing tours, family outings, and tourist travel from Viman Nagar Pune. Spacious seating and smooth ghat road travel ensure comfortable journeys suitable for family and corporate groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Viman Nagar to Goa Tempo Traveller",
    description: "Viman Nagar to Goa Tempo Traveller service provides premium long-distance transportation for beach vacations, sightseeing tours, bachelor trips, and family holidays from Viman Nagar Pune. Spacious seating and luggage capacity ensure smooth highway journeys suitable for tourist and group travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, offices, hotels, and residential locations across Viman Nagar Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller Viman Nagar",
    description: "Luxury Tempo Traveller Viman Nagar service offers premium transportation for weddings, corporate events, airport transfers, sightseeing tours, and family vacations. Spacious luxury interiors and elegant seating ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Viman Nagar Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "AC Tempo Traveller Viman Nagar",
    description: "AC Tempo Traveller Viman Nagar service provides premium air-conditioned transportation for business travel, educational tours, airport transfers, office outings, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Viman Nagar Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Non AC Tempo Traveller Viman Nagar",
    description: "Non AC Tempo Traveller Viman Nagar service offers affordable transportation for educational tours, local sightseeing, office travel, school trips, and group journeys. Spacious seating and smooth travel ensure comfortable experiences suitable for budget-friendly travel requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Viman Nagar Pune. Flexible booking options allow convenient non AC traveller reservations."
  },
  {
    name: "Affordable Tempo Traveller Viman Nagar",
    description: "Affordable Tempo Traveller Viman Nagar service provides economical transportation for family outings, school trips, office travel, sightseeing tours, weddings, and local or outstation journeys. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient affordable traveller reservations."
  }
],

tableData: [
  ["14 Seater Tempo Traveller Viman Nagar", "17 Seater Tempo Traveller Viman Nagar"],
  ["20 Seater Tempo Traveller Viman Nagar", "Tempo Traveller for Airport Pickup Viman Nagar"],
  ["Tempo Traveller for Corporate Viman Nagar", "Tempo Traveller for IT Employees Viman Nagar"],
  ["Tempo Traveller for Wedding Viman Nagar", "Viman Nagar to Shirdi Tempo Traveller"],
  ["Viman Nagar to Mumbai Tempo Traveller", "Viman Nagar to Lonavala Tempo Traveller"],
  ["Viman Nagar to Mahabaleshwar Tempo Traveller", "Viman Nagar to Goa Tempo Traveller"],
  ["Luxury Tempo Traveller Viman Nagar", "AC Tempo Traveller Viman Nagar"],
  ["Non AC Tempo Traveller Viman Nagar", "Affordable Tempo Traveller Viman Nagar"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller Hire in Viman Nagar Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller hire service in Viman Nagar Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate tours, family trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller hire in Viman Nagar Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller hire service in Viman Nagar Pune operates 24 hours for airport transfers, employee transportation, weddings, pilgrimage tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, office outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for office teams, family groups, wedding travel, tourists, and employee transportation."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Viman Nagar & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Viman Nagar, Kharadi, Wagholi, Chandan Nagar, Koregaon Park, Yerawada, Lohegaon, and Pune Airport for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller hire in Viman Nagar Pune?", answer: "Tempo Traveller hire service in Viman Nagar Pune provides comfortable group transportation for corporate travel, family tours, weddings, and outstation journeys." },
    { question: "Is Tempo Traveller booking available 24 hours in Viman Nagar?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller hire service in Viman Nagar Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel from Viman Nagar?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Viman Nagar Pune." },
    { question: "Do you provide Tempo Travellers for corporate events in Viman Nagar?", answer: "Yes, Aaradhya Travels provides Tempo Traveller hire service for corporate meetings, office outings, conferences, and employee transportation in Viman Nagar." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Viman Nagar Pune?", answer: "Yes, customers can easily book Tempo Traveller hire service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller hire charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller hire service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Joshi",
    feedback:
      "Travel coordination in Viman Nagar Pune became effortless with Aaradhya Travels providing a Tempo Traveller for our group. The ride was smooth, and everyone could travel together without any confusion or delay.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Deshmukh",
    feedback:
      "Aaradhya Travels arranged a Tempo Traveller hire in Viman Nagar Pune for our family function, and the experience was very well managed. The vehicle was clean and comfortable, making the journey enjoyable for all.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire in Viman Nagar Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-hire-in-viman-nagar.jpg",
  "description": "Book Tempo Traveller hire in Viman Nagar Pune with Aaradhya Travels for airport transfers, corporate travel, weddings, family trips, and outstation journeys. Available in 14, 17, and 20 seater tempo travellers across Viman Nagar and nearby Pune areas.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4172"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-hire-in-viman-nagar"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Tempo Traveller Hire in Viman Nagar Pune | Airport & Corporate Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller in Viman Nagar Pune with Aaradhya Travels. Affordable 14, 17, and 20 seater tempo traveller available for airport pickup, corporate travel, weddings, family trips, and outstation journeys."
  />

  <meta
    name="keywords"
    content="14 seater tempo traveller Viman Nagar, 17 seater tempo traveller Viman Nagar, 20 seater tempo traveller Viman Nagar, Tempo traveller for airport pickup Viman Nagar, Tempo traveller for corporate Viman Nagar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerhireinvimannagarpune;